/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Fix_Cps_MaxInputs */



/**
* | output |
* | --- |
* | "Reading rate too high (CPS)" |
*
* @param {Qc_Fix_Cps_MaxInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_fix_cps_max = /** @type {((inputs?: Qc_Fix_Cps_MaxInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Fix_Cps_MaxInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vitesse de lecture trop élevée (CPS)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lesegeschwindigkeit zu hoch (CPS)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Velocità di lettura troppo alta (CPS)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Слишком высокая скорость чтения (CPS)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Velocidad de lectura demasiado alta (CPS)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("阅读速度过快（CPS）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("読み取り速度が速すぎます（CPS）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पढ़ने की गति बहुत अधिक (CPS)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Velocidade de leitura demasiado alta (CPS)")
	return /** @type {LocalizedString} */ ("Reading rate too high (CPS)")
});